import { compose, head, pathOr, prop } from 'ramda'
import { gql } from '@apollo/client'
import React from 'react'

import { fieldsClient } from '../apollo/api'
import { usePromiseQuery } from '../apollo/_helpers/promiseQuery'

const QUERY = gql`
  query FieldValues($filter: FieldValueFilter) {
    fieldValues(filter: $filter) {
      originId
      value
    }
  }
`

export const useGetFieldValueAddressFromApi = () => {
  const [loading, setLoading] = React.useState(false)
  const query = usePromiseQuery(QUERY, { client: fieldsClient })

  const request = (originIds, fieldOrigins) => {
    if (!originIds) return Promise.resolve(null)
    setLoading(true)
    return new Promise((resolve, reject) =>
      query({ filter: { originIds, fieldOrigins, types: ['address'] } })
        .then(resp => compose(prop('value'), head, pathOr([], ['data', 'fieldValues']))(resp))
        .then(resolve)
        .catch(reject)
        .finally(() => setLoading(false))
    )
  }

  return [request, { loading }]
}

export const useGetFieldValuesAddressFromApi = () => {
  const [loading, setLoading] = React.useState(false)
  const query = usePromiseQuery(QUERY, { client: fieldsClient })

  const request = (originIds, fieldOrigins) => {
    if (!originIds) return Promise.resolve(null)
    setLoading(true)
    return new Promise((resolve, reject) =>
      query({ filter: { originIds, fieldOrigins, types: ['address'] } })
        .then(resp => compose(pathOr([], ['data', 'fieldValues']))(resp))
        .then(resolve)
        .catch(reject)
        .finally(() => setLoading(false))
    )
  }

  return [request, { loading }]
}
